import React from "react";
import { Typography } from "@mui/material";
import { BaseToolResult } from "./BaseToolResult";

interface RandomNumberToolResultProps {
  result: { randomNumber: number };
}

export const RandomNumberToolResult: React.FC<RandomNumberToolResultProps> = ({
  result,
}) => {
  return (
    <BaseToolResult icon="🎲">
      <Typography variant="body1">
        Generated random number: <Typography component="span" sx={{ fontWeight: "bold", color: "primary.main" }}>
          {result.randomNumber.toFixed(6)}
        </Typography>
      </Typography>
    </BaseToolResult>
  );
};